<template id="home">
    <v-ons-navigator swipeable
                     :page-stack="pageStack"
                     v-on:push-page="pageStack.push($event)"
                     v-on:pop-page="pageStack.pop()"
    ></v-ons-navigator>
</template>

<script>
    import main from './AbilityInput'

    export default {
        name: "Home.vue",
        // methods: {
        //     track () {
        //         this.$ga.page('/')
        //     }
        // },
        data() {
            return {
                pageStack: [main]
            }
        }
    }
</script>

<style scoped>

</style>
